class Cf7MultiStep {
  constructor(form) {
    this.form = form;
    this.steps = Array.from(this.form.querySelectorAll('.step'));
    this.current = 0;
    this.nextButtons = Array.from(this.form.querySelectorAll('.cf7-next'));
    this.prevButtons = Array.from(this.form.querySelectorAll('.cf7-prev'));

    this.bindListeners();
    this.showStep(this.current);
  }

  bindListeners() {
    this.nextButtons.forEach(btn =>
      btn.addEventListener('click', this.handleNext.bind(this))
    );
    this.prevButtons.forEach(btn =>
      btn.addEventListener('click', this.handlePrev.bind(this))
    );
  }

  handleNext() {
    if (this.validateStep(this.current) && this.current < this.steps.length - 1) {
      this.current++;
      this.showStep(this.current);
      this.updateTitlesVisibility(this.current);
    }
  }

  handlePrev() {
    if (this.current > 0) {
      this.current--;
      this.showStep(this.current);
      this.updateTitlesVisibility(this.current);
    }
  }
  

  updateTitlesVisibility(idx) {
    const titleStep1 = document.querySelector('.contact__title--step1');
    const titleStep2 = document.querySelector('.contact__title--step2');
    if (titleStep1) {
      if (idx === 0) {
        titleStep1.classList.add('show');
        titleStep1.setAttribute('aria-hidden', 'false');
        titleStep2.setAttribute('aria-hidden', 'true');
        titleStep2.classList.remove('show');
        titleStep2.classList.add('hide');

      }
    }
  
    if (titleStep2) {
      if (idx === 1) {
        titleStep1.classList.add('hide');
        titleStep1.setAttribute('aria-hidden', 'true');
        titleStep2.classList.add('show');
        titleStep2.classList.remove('hide');
        titleStep2.setAttribute('aria-hidden', 'false');
      }
    }
  }

  showStep(idx) {
    this.steps.forEach((s, i) => {
      s.style.display = (i === idx ? 'block' : 'none');
    });
    this.updateProgressIndicator();
  }

  validateStep(idx) {
    const inputs = this.steps[idx].querySelectorAll('[aria-required="true"]');
    let ok = true;
    inputs.forEach(i => {
      if (!i.value.trim()) {
        i.classList.add('wpcf7-not-valid');
        ok = false;
      } else {
        i.classList.remove('wpcf7-not-valid');
      }
    });
    return ok;
  }

  updateProgressIndicator() {
    const indicator = document.querySelector('.contact__navigation');
    if (!indicator) return;

    const blocks = indicator.querySelectorAll('span');

    const totalSteps = 3;
    let progress = 1;

    if (this.form.dataset.status === 'sent') {
      progress = 3;
    }else {
      progress = Math.round(((this.current + 1) / totalSteps) * 16);
    }

    indicator.setAttribute('data-progress', progress);

    blocks.forEach((block, index) => {
      if (index < progress) {
        block.classList.add('active');
      } else {
        block.classList.remove('active');
      }
    });
  }
}

function initCf7MultiStep() {
  const forms = document.querySelectorAll('.wpcf7-form');
  forms.forEach(form => new Cf7MultiStep(form));
}

document.addEventListener('DOMContentLoaded', () => {
  const indicator = document.querySelector('.progress-blocks');
  if (indicator && indicator.children.length === 0) {
    for (let i = 0; i < 16; i++) {
      indicator.appendChild(document.createElement('span'));
    }
  }

  initCf7MultiStep()
});

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.template-contact form');
  if (!form) return;

  const submitButton = form.querySelector('input[type="submit"]');
  const inputs = form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"]');
  const checkbox = form.querySelector('input.accept-box');

  if(form.dataset.status === 'sent') {
    const steps = document.querySelectorAll('.step');
    const tydiv = document.querySelector('.thank-you');
    const pageTitle1 = document.querySelector('.contact__title--step1');
    const pageTitle3 = document.querySelector('.contact__title--step3');
    pageTitle1.classList.add('hide');
    pageTitle1.classList.remove('show');
    pageTitle3.classList.add('show');
    pageTitle3.classList.remove('hide');
    steps.forEach(step => {
      step.style.display = 'none';
    });
    tydiv.style.display = 'block';

    
    const companyName = document.querySelector('input[name="your-company"]');

    const evento = {
      event: 'send_contactForm',
      item_company: companyName
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evento);
    
  }

  function checkFormFilled() {
    let allFilled = true;

    inputs.forEach(input => {
      if (!input.value.trim()) {
        allFilled = false;
      }
    });

    // También verificar si el checkbox está marcado
    if (!checkbox.checked) {
      allFilled = false;
    }

    submitButton.disabled = !allFilled;
  }

  // Inicialmente desactivado
  submitButton.disabled = true;

  // Eventos de entrada para los inputs
  inputs.forEach(input => {
    input.addEventListener('input', checkFormFilled);
  });

  // Evento de cambio para el checkbox
  checkbox.addEventListener('change', checkFormFilled);
});